import { on } from "@ember/modifier";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import DButton from "discourse/ui-kit/d-button";
import DConditionalLoadingSpinner from "discourse/ui-kit/d-conditional-loading-spinner";
import ParamInputForm from "../../../components/param-input-form";
import QueryResult from "../../../components/query-result";
import QueryResultDownloadButtons from "../../../components/query-result-download-buttons";

export default <template>
  <section class="user-content">
    <h1>{{@controller.model.name}}</h1>
    <p>{{@controller.model.description}}</p>

    <form class="query-run" {{on "submit" @controller.run}}>
      {{#if @controller.hasParams}}
        <ParamInputForm
          @initialValues={{@controller.parsedParams}}
          @paramInfo={{@controller.model.param_info}}
          @onRegisterApi={{@controller.onRegisterApi}}
        />
      {{/if}}

      <div class="query-run-actions">
        <div class="query-run-actions__left">
          <DButton
            {{didInsert @controller.runOnLoad}}
            @action={{@controller.run}}
            @icon="play"
            @label="explorer.run"
            @type="submit"
            class="btn-primary query-run__submit"
          />

          <DButton
            @action={{@controller.toggleBookmark}}
            @translatedLabel={{@controller.bookmarkLabel}}
            @icon={{@controller.bookmarkIcon}}
            class={{@controller.bookmarkClassName}}
          />
        </div>

        {{#if @controller.showResults}}
          <div class="query-run-actions__right">
            <QueryResultDownloadButtons
              @query={{@controller.model}}
              @content={{@controller.results}}
              @group={{@controller.group}}
              class="query-result-download-buttons--inline"
            />
          </div>
        {{/if}}
      </div>
    </form>

    <hr />

    <DConditionalLoadingSpinner @condition={{@controller.loading}} />

    {{#if @controller.results}}
      <div class="query-results">
        {{#if @controller.showResults}}
          <QueryResult
            @query={{@controller.model}}
            @content={{@controller.results}}
            @group={{@controller.group}}
            @showDownloads={{false}}
          />
        {{else}}
          {{#each @controller.results.errors as |err|}}
            <pre class="query-error"><code>{{~err}}</code></pre>
          {{/each}}
        {{/if}}
      </div>
    {{/if}}
  </section>
</template>
